const state = {
  labType: "labInfo", // 选择的实验室信息
};

const mutations = {
  // 唯一 mutation：更新 status
  SET_LABTYPE(state: { labType: any }, type: any) {
    state.labType = type;
  },
};

export default {
  namespaced: true, // 启用命名空间
  state,
  mutations,
};
